
export const examples = {
    'Hotline Miami': '🔥➖🌴',
    'Planet of the apes': '🌎🐵',
    'The silence of the lambs': '🤫🐑',
    'Interview with the vampire': '🎤🧛‍♀️',
    'The dark side of the moon': '🌑',
    'Psycho': '🔪🚿',
    '12 monkeys': '🐵🐵🐵🐵🐵🐵🐵🐵🐵🐵🐵🐵',
    'Twin peaks': '🗻🗻',
    'Scream': '😱🔪',
    'Game of thrones': '♟🥶🐉',
    'Brexit': '🇬🇧🚪👋',
    '12 angry men': '😠😠😠😠😠😠😠😠😠😠😠😠',
    'A clockwork orange': '⏰🍊',
    'Flat earth': '➖🌎',
    'Guns and Roses': '🔫🌹',
    'Fear and Loathing in Las Vegas': '😱🤪🌴🎰',
    'Four weddings and a funeral': '💒💒💒💒⚰',
    'The Butterfly Effect': '🦋🎲',
}

export default examples


// WEBPACK FOOTER //
// ./src/utils/examples.js